export interface ISignUpState {
	userData: any;
}

export const initialSignUpState: ISignUpState = {
	userData: {},
};
